<template>
  <div>
    <el-drawer class="sideDrawer tabSideDrawer" destroy-on-close :size="drawerSize" title="提示" :visible.sync="riskIndicators" :before-close="handleClose">
      <div slot="title" class="dialog-title">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane v-for="item in riskTabs" :key="item.name" :label="item.label" :name="item.name"> </el-tab-pane>
        </el-tabs>
      </div>
      <i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
      <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
      <div class="form-content">
        <el-form ref="form" :model="form" label-width="140px" :rules="rules">
          <template v-if="activeName === 'first'">
            <el-row>
              <el-col :span="12">
                <el-form-item label="风险维度" prop="dimension_key">
                  <el-select v-model="form.dimension_key" placeholder="请选择" @change="dimensionChange" filterable :disabled="tenantId != '-1'">
                    <el-option v-for="item in dimensionOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="风险模版" prop="bo_def_key">
                  <el-select v-model="form.bo_def_key" placeholder="选择维度后选择" @change="boDefChange" filterable :disabled="tenantId != '-1'">
                    <el-option v-for="item in bodefOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="风险名称" prop="target_key">
                  <el-select v-model="form.target_key" placeholder="选择模板后选择" @change="targetChange" filterable :disabled="tenantId != '-1'">
                    <el-option v-for="item in targetNameOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="关联维度" prop="associated_dimension_list">
                  <el-select
                    v-model="form.associated_dimension_list"
                    placeholder="请选择"
                    @change="associatedDimensionChange"
                    filterable
                    multiple
                    :disabled="tenantId != '-1'"
                  >
                    <el-option v-for="item in AssociatedDimensionEnums" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="风险描述" prop="target_def">
                  <el-input type="textarea" v-model="form.target_def" :disabled="tenantId != '-1'"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="风险模型" prop="model_vo">
                  <el-select v-model="form.model_vo" placeholder="选择模板后选择" @change="modelChange" filterable>
                    <el-option v-for="item in modelOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="风险条件" prop="target_condition">
                  <el-link type="primary" :underline="false" @click="showConditionBuild()">设置条件</el-link>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="风险指标" prop="target_field">
                  <el-select v-model="form.target_field" placeholder="选择风险模型后选择" filterable>
                    <el-option v-for="item in fieldOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="计算函数" prop="function_method">
                  <el-select v-model="form.function_method" placeholder="选择计算函数" filterable>
                    <el-option v-for="item in functionMethodOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <div class="labelrag" v-for="(param, $index) in functionParams" :key="param.key">
                  <el-row>
                    <el-col :span="18">
                      <el-form-item :label="param.label" :prop="param.value">
                        <el-select v-model="param.value" placeholder="选择风险模型后选择" filterable>
                          <el-option v-for="item in functionParamsOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-button v-if="$index === 0" type="primary" size="small" @click="addFunctionParam">添加</el-button>
                      <el-button v-if="$index !== 0" size="small" type="text" @click="removeFunctionParam($index)">删除</el-button>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
          </template>
          <div v-if="activeName !== 'first'">
            <div class="title_text">
              <div class="title_border"></div>
              <span>风险信息</span>
            </div>
            <el-row>
              <el-col :span="20">
                <el-form-item label="风险标题" :prop="`${fieldName}` + '.remind_title'">
                  <el-input v-model="form[fieldName].remind_title" type="textarea" @blur="blurEvent" @input="$forceUpdate()"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <form-field-selector
                  v-if="tenantId === '-1'"
                  :boKey="form.bo_def_key"
                  @setField="(params) => setField(params, 'remind_title')"
                ></form-field-selector>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="风险描述" :prop="`${fieldName}` + '.risk_describe'">
                  <el-input v-model="form[fieldName].risk_describe" type="textarea" @blur="blurEvent" @input="$forceUpdate()"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <form-field-selector :boKey="form.bo_def_key" @setField="(params) => setField(params, 'risk_describe')"></form-field-selector>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="门户显示" :prop="form[fieldName].is_portal + ''">
                  <el-switch
                    v-model="form[fieldName].is_portal"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    :active-value="1"
                    :inactive-value="0"
                    @change="$forceUpdate()"
                  >
                  </el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="form[fieldName].is_portal == 1" :key="form[fieldName].portal_type_list">
                <el-form-item label="门户页面" :prop="`${fieldName}` + '.portal_type_list'">
                  <el-select v-model="form[fieldName].portal_type_list" placeholder="请选择" multiple @change="portalTypeChange">
                    <el-option v-for="item in portalTypeOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="form[fieldName].is_portal == 1" :key="form[fieldName].statistics_data">
              <el-col :span="12">
                <el-form-item label="统计数据" :prop="form[fieldName].statistics_data + ''">
                  <el-select v-model="form[fieldName].statistics_data" @change="$forceUpdate()" filterable :disabled="tenantId != '-1'">
                    <el-option v-for="item in statisticsDataOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="显示单位" :prop="form[fieldName].show_unit + ''">
                  <el-select v-model="form[fieldName].show_unit" @change="$forceUpdate()" placeholder="请选择" :disabled="tenantId != '-1'">
                    <el-option
                      v-for="item in form[fieldName].statistics_data === 'number' ? showUnitOptionsOwn : showUnitOptionsMoney"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="form[fieldName].is_portal == 1">
              <el-col :span="16">
                <el-form-item label="统计字段" :prop="form[fieldName].statistics_field + ''">
                  <el-select
                    v-model="form[fieldName].statistics_field"
                    placeholder="选择模板后选择"
                    @change="$forceUpdate()"
                    filterable
                    :disabled="tenantId != '-1'"
                  >
                    <el-option v-for="item in targetNameOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="风险任务" :prop="form[fieldName].F_send_task + ''" v-if="['yjtx', 'fxtx'].includes(form[fieldName].risk_level)">
                  <el-switch
                    v-model="form[fieldName].F_send_task"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    :active-value="1"
                    :inactive-value="0"
                    @change="$forceUpdate()"
                  >
                  </el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="任务整改期限(天)"
                  :prop="form[fieldName].task_deadline + ''"
                  v-if="['yjtx', 'fxtx'].includes(form[fieldName].risk_level) && form[fieldName].F_send_task == 1"
                >
                  <el-input type="number" v-model="form[fieldName].task_deadline"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="title_text">
              <div class="title_border"></div>
              <span>风险评估分析</span>
            </div>
            <el-row>
              <el-col :span="12">
                <el-form-item label="条件运算符" :prop="`${fieldName}` + '.condition_operator'" :rules="conditionOperatorRules">
                  <el-select v-model="form[fieldName].condition_operator" placeholder="请选择" filterable @change="$forceUpdate()">
                    <el-option v-for="item in conditionOperatorOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="条件控制值" :prop="`${fieldName}` + '.condition_ctrl_value'">
                  <el-input v-model="form[fieldName].condition_ctrl_value" @input="$forceUpdate()" :disabled="isCanEdit(form.target_key)"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="['ybtx', 'yjtx', 'fxtx'].includes(form[fieldName].risk_level)">
              <el-col :span="24">
                <el-form-item label="风险值">
                  <riskStatusTable ref="riskStatu" :tabActive="form[fieldName].risk_level" @radioChangeone="radioChange"></riskStatusTable>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="['ybtx', 'yjtx', 'fxtx'].includes(form[fieldName].risk_level)">
              <el-col :span="12">
                <el-form-item label="发生概率" :prop="`${fieldName}` + '.probability'" :rules="probabilityRules">
                  <el-select v-model="form[fieldName].probability" disabled placeholder="请选择">
                    <el-option v-for="item in RiskYEnums" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="风险影响" :prop="`${fieldName}` + '.effect'" :rules="effectRules">
                  <el-select v-model="form[fieldName].effect" disabled placeholder="请选择">
                    <el-option v-for="item in RiskXEnums" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="['ybtx', 'yjtx', 'fxtx'].includes(form[fieldName].risk_level)">
              <el-col :span="12">
                <el-form-item label="风险值" :prop="`${fieldName}` + '.risk_value'" :rules="riskValueRules" :key="form[fieldName].risk_value">
                  <el-input v-model="form[fieldName].risk_value" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="风险等级" :prop="`${fieldName}` + '.risk_level'" :rules="riskLevelRules">
                  <el-select v-model="form[fieldName].risk_level" disabled placeholder="请选择">
                    <el-option v-for="item in ReminderRiskLevelEnums" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="title_text">
              <div class="title_border"></div>
              <span>提醒规则</span>
            </div>
            <el-row>
              <el-col :span="12">
                <el-form-item label="提醒时间" :prop="`${fieldName}` + '.remind_time'" :rules="remindTimeRules">
                  <el-link type="primary" :underline="false" @click="showNoticeTime" style="margin-left: 10px">设置提醒时间</el-link>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-col :span="12">
                  <el-form-item label="提醒状态" :prop="`${fieldName}` + '.state'">
                    <el-switch
                      v-model="form[fieldName].state"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      active-value="1"
                      inactive-value="0"
                      @change="$forceUpdate()"
                    >
                    </el-switch>
                  </el-form-item>
                </el-col>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="提醒方式" :prop="`${fieldName}` + '.remind_way_list'" :rules="remindWayListRules">
                  <el-select v-model="form[fieldName].remind_way_list" multiple @change="remindWayChange" placeholder="请选择">
                    <el-option v-for="item in remindWayOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="tenantId == -1">
                <el-form-item label="是否保存" :prop="`${fieldName}` + '.is_save'">
                  <el-switch
                    v-model="form[fieldName].is_save"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-value="1"
                    inactive-value="0"
                    @change="$forceUpdate()"
                  >
                  </el-switch>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="提醒人" :prop="`${fieldName}` + '.reminder_members'" :rules="reminderMembersRules">
                  <el-input v-model="form[fieldName].reminder_members"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-link type="primary" :underline="false" @click="setPerson()" style="margin-left: 10px">设置提醒人</el-link>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item label="提醒文字" :prop="`${fieldName}` + '.remind_word_diy'" :rules="remindWordDiyRules">
                  <el-input v-model="form[fieldName].remind_word_diy" type="textarea" @input="$forceUpdate()" @blur="blurEvent"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <form-field-selector :boKey="form.bo_def_key" @setField="(params) => setField(params, 'remind_word_diy')"></form-field-selector>
              </el-col>
              <el-col :span="2">
                <el-link type="primary" :underline="false" v-if="tenantId != '-1'" style="margin-left: 10px" @click="handleInitText">恢复默认</el-link>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
      <div class="demo-drawer__footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="saveRiskIndex" v-loading.fullscreen.lock="loading">确 定</el-button>
      </div>
    </el-drawer>
    <notice-time v-if="noticeTimeShow" :show="noticeTimeShow" :time="form[fieldName].remind_time" @closeNoticeTime="closeNoticeTime"></notice-time>
    <notice-person-selector
      ref="noticePersonSelectorRef"
      :show="showPerson"
      v-model="form.sub_business_reminder_member"
      :boKey="form.bo_def_key"
      @close="close"
      @onConfirm="onConfirm"
    ></notice-person-selector>
    <!--条件-->
    <rule-condition-build-dialog @onConfirm="conditionDialogConfirm" ref="ruleConditionDialog" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import utils from '@/utils.js'
import noticeTime from './noticeTime.vue'
import noticePersonSelector from './noticePersonSelector.vue'
import formFieldSelector from './formFieldSelector.vue'
import riskStatusTable from './components/riskStatusTable.vue'
import RuleConditionBuildDialog from '@/components/tenant/rule/RuleConditionBuildDialog.vue'
export default {
  props: {
    tabsVal: {
      type: String,
      default: () => 1
    },
    show: {
      type: Boolean,
      default: () => false
    },
    noticeData: {
      type: Object,
      default: () => {}
    },
    isEdit: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    ...mapState({
      allDataDict: (state) => state.user.allDataDict,
      allEnumerate: (state) => state.user.allEnumerate,
      riskLevelOptions: (state) => {
        let arr = utils.findDictList('fxdj', state.user.allDataDict)
        return arr.map((item) => {
          return {
            value: item.key,
            label: item.name
          }
        })
      },
      portalTypeOptions: (state) => {
        return utils.getAllEnumerateAttr({
          isShowList: true,
          typeKey: 'PortalEnum',
          allData: state.user.allEnumerate
        })
      },
      statisticsDataOptions: (state) => {
        return utils.getAllEnumerateAttr({
          isShowList: true,
          typeKey: 'StatisticDataEnum',
          allData: state.user.allEnumerate
        })
      },
      showUnitOptionsOwn: (state) => {
        return utils.getAllEnumerateAttr({
          isShowList: true,
          typeKey: 'NumberUnitEnum',
          allData: state.user.allEnumerate
        })
      },
      showUnitOptionsMoney: (state) => {
        return utils.getAllEnumerateAttr({
          isShowList: true,
          typeKey: 'AmountUnitEnum',
          allData: state.user.allEnumerate
        })
      },
      ReminderRiskLevelEnums: (state) => {
        return utils.getAllEnumerateAttr({
          isShowList: true,
          typeKey: 'ReminderRiskLevelEnums',
          allData: state.user.allEnumerate
        })
      },
      AssociatedDimensionEnums: (state) => {
        return utils.getAllEnumerateAttr({
          isShowList: true,
          typeKey: 'AssociatedDimensionEnums',
          allData: state.user.allEnumerate
        })
      },
      RiskXEnums: (state) => {
        return utils.getAllEnumerateAttr({
          isShowList: true,
          typeKey: 'RiskXEnums',
          allData: state.user.allEnumerate
        })
      },
      RiskYEnums: (state) => {
        return utils.getAllEnumerateAttr({
          isShowList: true,
          typeKey: 'RiskYEnums',
          allData: state.user.allEnumerate
        })
      }
    })
  },
  components: {
    RuleConditionBuildDialog,
    noticeTime,
    noticePersonSelector,
    formFieldSelector,
    riskStatusTable
  },

  data() {
    return {
      drawerSize: '70%',
      loading: false,
      showPerson: false,
      riskIndicators: false,
      noticeTimeShow: false,
      activeName: 'first',
      radioValue: '',
      riskTabs: [
        {
          name: 'first',
          label: '风险指标定义'
        },
        {
          name: 'second',
          label: '普通提醒',
          show: 'sub_business_reminder_pttx'
        },
        {
          name: 'third',
          label: '一般风险',
          show: 'sub_business_reminder_ybtx'
        },
        {
          name: 'fourth',
          label: '中等风险',
          show: 'sub_business_reminder_yjtx'
        },
        {
          name: 'fifth',
          label: '重大风险',
          show: 'sub_business_reminder_fxtx'
        }
      ],
      form: {
        word_template: '2',
        bo_def_key: '',
        target_key: '',
        target_def: '',
        model_vo: '',
        target_field: '',
        target_condition: {},
        target_function: [],
        associated_dimension: '',
        associated_dimension_list: [],
        sub_business_reminder_fxtx: {},
        sub_business_reminder_pttx: {},
        sub_business_reminder_ybtx: {},
        sub_business_reminder_yjtx: {}
      },
      isShowRisk: false,
      dimensionOptions: [],
      bodefOptions: [],
      targetNameOptions: [],
      blurIndex: null,
      rules: {
        associated_dimension_list: [{ required: true, message: '请选择关联维度', trigger: 'change' }],
        dimension_key: [{ required: true, message: '请选择维度', trigger: 'change' }],
        bo_def_key: [{ required: true, message: '请选择风险模板', trigger: 'change' }],
        target_key: [{ required: true, message: '请选择风险', trigger: 'change' }],
        target_def: [{ required: true, message: '请输入风险定义', trigger: 'blur' }],
        word_template: [{ required: true, message: '请选择提醒文字模板', trigger: 'change' }],
        template_key: [{ required: true, message: '请选择系统提醒模板', trigger: 'change' }],
        model_vo: [{ required: true, message: '请选择风险模型', trigger: 'change' }],
        target_field: [{ required: true, message: '请选择指标字段', trigger: 'change' }]
      },
      remindTimeRules: [{ required: true, message: '请选择模提醒时间', trigger: 'change' }],
      remindWordDiyRules: [{ required: true, message: '请输入自定义提醒模板', trigger: 'blur' }],
      remindWayListRules: [{ required: true, message: '请选择提醒方式', trigger: 'change' }],
      reminderMembersRules: [{ required: true, message: '请选择提醒人', trigger: 'change' }],
      conditionOperatorRules: [{ required: true, message: '请选择条件运算符', trigger: 'change' }],
      probabilityRules: [{ required: true, message: '请选择风险值', trigger: 'blur' }],
      effectRules: [{ required: true, message: '请选择风险值', trigger: 'blur' }],
      riskValueRules: [{ required: true, message: '请选择风险值', trigger: 'blur' }],
      riskLevelRules: [{ required: true, message: '请选择风险值', trigger: 'blur' }],
      conditionOperatorOptions: [
        { value: 'GT', label: '大于' },
        { value: 'LT', label: '小于' },
        { value: 'GE', label: '大于等于' },
        { value: 'LE', label: '小于等于' },
        { value: 'EQ', label: '等于' },
        { value: 'NE', label: '不等于' },
        { value: 'LKS', label: '左相似' },
        { value: 'LKE', label: '右相似' },
        { value: 'IN', label: '包含' },
        { value: 'BETWEEN_CONTAIN_BEHIND', label: '介于(含后值)' },
        { value: 'BETWEEN_CONTAIN_FRONT', label: '介于(含前值)' },
        { value: 'BETWEEN', label: '介于(含前后值)' },
        { value: 'BETWEEN_NO_CONTAIN', label: '介于(不含前后值)' }
      ],
      remindWayOptions: [
        { value: 'inner', label: '站内消息' },
        { value: 'dingTalk', label: '钉钉' },
        { value: 'wxEnterprise', label: '微信' }
        // { value: "sms", label: "短信" }
      ],
      tenantId: '-1',
      fieldName: '',
      subName: [],
      functionMethodOptions: [
        { value: 'durationDay', label: '计算日期天数', returnType: 'int' },
        { value: 'rate', label: '计算比例', returnType: 'double' },
        { value: 'add', label: '计算相加', returnType: 'double' },
        { value: 'subtract', label: '计算相减', returnType: 'double' },
        { value: 'multiply', label: '计算相乘', returnType: 'double' },
        { value: 'divide', label: '计算相除', returnType: 'double' }
      ],
      functionParams: [{ key: 'param1', label: '函数参数1' }],
      conditionParams: {},
      modelOptions: [],
      fieldOptions: [],
      functionParamsOptions: [
        {
          value: '_NOW',
          label: '当前日期'
        }
      ]
    }
  },
  mounted() {
    if (sessionStorage.currentTenantId) {
      this.tenantId = sessionStorage.currentTenantId
    }
    this.remindWordOptions = []
    this.modelOptions = []
    this.$http.get('${risk}/rule/business_reminder/getAllDimension').then((res) => {
      if (res.data) {
        res.data.forEach((item) => {
          this.dimensionOptions.push({
            value: item.dimension_key,
            label: item.dimension
          })
        })
      }
    })
    this.$http.get('${risk}/management/risk_model/model').then((res) => {
      if (res.data) {
        res.data.forEach((item) => {
          this.modelOptions.push({
            value: item.value,
            label: item.label
          })
        })
      }
    })
  },

  methods: {
    openLink(data) {
      this.activeName = 'first'
      this.riskIndicators = true
      this.$nextTick(() => {
        if (data) {
          data.associated_dimension_list = []
          data.associated_dimension_list = data.associated_dimension ? data.associated_dimension.split(',') : []
          this.form = data
          console.info(this.form)
          this.subName = []
          if (this.tenantId != -1) {
            Object.keys(data).forEach((key) => {
              if (key.indexOf('sub_') > -1) {
                this.subName.push(key)
              }
            })
            this.riskTabs = this.riskTabs.filter((c) => this.subName.includes(c.show))
            this.riskTabs.unshift({
              name: 'first',
              label: '风险指标定义'
            })
          }
          this.bodefOptions = []
          this.$http.get('${risk}/rule/business_reminder/getModuleByDimensionKey?key=' + this.form.dimension_key).then((res) => {
            if (res.data) {
              res.data.forEach((item) => {
                this.bodefOptions.push({
                  value: item.bo_def_key,
                  label: item.bo_def
                })
              })
            }
          })
          this.targetNameOptions = []
          this.$http.get('${risk}/rule/business_reminder/getTargetByModuleKey?key=' + this.form.bo_def_key).then((res) => {
            if (res.data) {
              res.data.forEach((item) => {
                this.targetNameOptions.push({
                  value: item.target_key,
                  label: item.target_name
                })
              })
            }
          })
          this.modelChange(this.form.model_vo)
          if (data && data.target_function && data.target_function.length > 0) {
            // this.form.model_vo = data[key].function_json[0].entityIdentify;
            // 初始化下模型下的字段
            this.form.function_method = data.target_function[0].functionMethod
            this.functionParams = []
            for (let i = 0; i < data.target_function[0].params.split(',').length; i++) {
              const paramKey = data.target_function[0].params.split(',')[i]
              this.functionParams.push({
                key: 'param' + (i + 1),
                label: '函数参数' + (i + 1),
                value: paramKey
              })
            }
          }

          if (data && data.target_condition) {
            this.conditionParams = data.target_condition
          }
        } else {
          this.form = {
            word_template: '2',
            bo_def_key: '',
            target_key: '',
            target_def: '',
            model_vo: '',
            target_field: '',
            target_condition: {},
            target_function: [],
            associated_dimension: '',
            associated_dimension_list: [],
            sub_business_reminder_fxtx: {},
            sub_business_reminder_pttx: {},
            sub_business_reminder_ybtx: {},
            sub_business_reminder_yjtx: {}
          }
        }
      })
    },
    /**
     * @description: 关闭风险dialog
     * @return {*}
     */
    handleClose() {
      this.riskIndicators = false
      this.riskTabs = [
        {
          name: 'first',
          label: '风险指标定义'
        },
        {
          name: 'second',
          label: '普通提醒',
          show: 'sub_business_reminder_pttx'
        },
        {
          name: 'third',
          label: '一般风险',
          show: 'sub_business_reminder_ybtx'
        },
        {
          name: 'fourth',
          label: '中等风险',
          show: 'sub_business_reminder_yjtx'
        },
        {
          name: 'fifth',
          label: '重大风险',
          show: 'sub_business_reminder_fxtx'
        }
      ]
      this.form = {
        word_template: '2',
        bo_def_key: '',
        target_key: '',
        target_def: '',
        model_vo: '',
        target_field: '',
        target_condition: {},
        target_function: [],
        associated_dimension: '',
        associated_dimension_list: [],
        sub_business_reminder_fxtx: {},
        sub_business_reminder_pttx: {},
        sub_business_reminder_ybtx: {},
        sub_business_reminder_yjtx: {}
      }
      this.functionParams = []
      this.$emit('close')
    },
    /**
     * @description: 点击tab触发事件
     * @return {*}
     */
    handleClick() {
      this.$nextTick(() => {
        let returnFileName = {
          second: 'sub_business_reminder_pttx',
          third: 'sub_business_reminder_ybtx',
          fourth: 'sub_business_reminder_yjtx',
          fifth: 'sub_business_reminder_fxtx'
        }
        let RiskLevelEnums = {
          second: 'pttx',
          third: 'ybtx',
          fourth: 'yjtx',
          fifth: 'fxtx'
        }
        this.isShowRisk = true
        this.noticeTimeShow = false
        this.fieldName = returnFileName[this.activeName]
        if (!this.form[this.fieldName] && this.activeName != 'first') {
          this.form[this.fieldName] = {
            dimension: '',
            dimension_key: '',
            bo_def_key: '',
            bo_def: '',
            target_key: '',
            target_name: '',
            condition_operator: '',
            condition_ctrl_value: '',
            risk_level: '',
            remind_time: '',
            remind_way: '',
            state: '0',
            is_save: this.tenantId == -1 ? '0' : '1',
            form_data_rev_: '',
            reminder_no: '',
            target_def: '',
            remind_word_diy: '',
            sub_business_reminder_member: [],
            reminder_members: '',
            remind_title: '',
            is_portal: 0,
            statistics_field: '',
            risk_describe: '',
            associated_dimension: '',
            remind_way_list: ''
          }
        }
        if (this.fieldName) this.form[this.fieldName].risk_level = RiskLevelEnums[this.activeName]
        if (this.form[this.fieldName] && this.form[this.fieldName].remind_way)
          this.form[this.fieldName].remind_way_list = this.form[this.fieldName].remind_way.split(',')
        if (this.form[this.fieldName] && this.form[this.fieldName].portal_type) {
          this.form[this.fieldName].portal_type_list = this.form[this.fieldName].portal_type.split(',')
        }
        if (['ybtx', 'yjtx', 'fxtx'].includes(RiskLevelEnums[this.activeName]) && this.form[this.fieldName].risk_value) {
          this.$nextTick(() => {
            this.$refs.riskStatu.initValue(
              this.form[this.fieldName].radioValue
                ? this.form[this.fieldName].radioValue
                : `${this.form[this.fieldName].probability}${this.form[this.fieldName].effect}${this.form[this.fieldName].risk_value}`
            )
          })
        }
        console.log(this.form[this.fieldName], 111)
        this.$forceUpdate()
      })
    },
    /**
     * @description: 维度选中后联动模板
     * @param {*} val
     * @return {*}
     */
    dimensionChange(val) {
      this.form.bo_def_key = ''
      this.form.target_key = ''
      this.bodefOptions = []
      this.targetNameOptions = []
      this.dimensionOptions.forEach((item) => {
        if (item.value == val) {
          this.form.dimension = item.label
        }
      })
      this.$http.get('${risk}/rule/business_reminder/getModuleByDimensionKey?key=' + val).then((res) => {
        if (res.data) {
          res.data.forEach((item) => {
            this.bodefOptions.push({
              value: item.bo_def_key,
              label: item.bo_def
            })
          })
        }
      })
    },
    /**
     * @description: 模板选中后联动指标
     * @param {*} val
     * @return {*}
     */
    boDefChange(val) {
      this.form.target_key = ''
      this.targetNameOptions = []
      this.bodefOptions.forEach((item) => {
        if (item.value == val) {
          this.form.bo_def = item.label
        }
      })
      this.$http.get('${risk}/rule/business_reminder/getTargetByModuleKey?key=' + val).then((res) => {
        if (res.data) {
          res.data.forEach((item) => {
            this.targetNameOptions.push({
              value: item.target_key,
              label: item.target_name
            })
          })
        }
      })
    },
    /**
     * @description: 指标选中
     * @param {*} val
     * @return {*}
     */
    targetChange(val) {
      this.targetNameOptions.forEach((item) => {
        if (item.value == val) {
          this.form.target_name = item.label
        }
      })
    },
    /**
     * @description: 保存数据
     * @return {*}
     */
    saveRiskIndex() {
      this.loading = true
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.info(this.functionParams)
          if (this.activeName !== 'first') {
            if (this.form[this.fieldName].is_portal == 1 && this.form[this.fieldName].portal_type == '') {
              return this.$message({
                type: 'error',
                message: '请选择显示门户页面'
              })
            }
            if (this.form[this.fieldName].F_send_task == 1 && this.form[this.fieldName].task_deadline == '') {
              return this.$message({
                type: 'error',
                message: '任务整改期限(天)必填'
              })
            }
          }

          if (this.form) {
            this.form.target_condition = this.conditionParams
            if (this.form.function_method) {
              let functionParamsStr = []
              this.functionParams.forEach((param) => {
                functionParamsStr.push(param.value)
              })
              this.form.target_function = [
                {
                  entityIdentify: this.form.model_vo,
                  functionName: this.form.function_method,
                  functionDesc: this.functionMethodOptions.find((op) => op.value === this.form.function_method).label,
                  functionMethod: this.form.function_method,
                  functionReturnType: this.functionMethodOptions.find((op) => op.value === this.form.function_method).returnType,
                  params: functionParamsStr.join(','),
                  field: this.form.target_field,
                  isEffect: '1'
                }
              ]
            }
          }

          let params = {
            ...this.form
          }
          params.associated_dimension = params.associated_dimension_list.join(',')
          if (this.isEdit) {
            this.$http.put('${risk}/rule/business_reminder/', params).then((res) => {
              if (res.data.state) {
                this.loading = false
                this.$message.info('保存成功！')
              } else {
                this.loading = false
                this.$message.error('保存失败！')
              }
              this.handleClose()
            })
          }
          if (!this.isEdit) {
            this.$http.post('${risk}/rule/business_reminder/', params).then((res) => {
              if (res.data.state) {
                this.loading = false
                this.$message.info('保存成功！')
              } else {
                this.loading = false
                this.$message.error('保存失败！')
              }
              this.handleClose()
            })
          }
          setTimeout(() => {
            this.loading = false
          }, 2000)
        } else {
          this.loading = false
          return false
        }
      })
    },
    /**
     * @description: 距离员工生日天数 本月员工生日  条件控制值不能修改
     * @param {*} type
     * @return {*}
     */
    isCanEdit(type) {
      if (this.tenantId == '-1') {
        return false
      } else {
        return type === 'birthday_remain_days_month' || type === 'birthday_remain_days'
      }
    },
    /**
     * @description: 设置提醒时间
     * @return {*}
     */
    showNoticeTime() {
      this.noticeTimeShow = true
    },
    /**
     * @description: 提醒时间关闭
     * @param {*} val
     * @return {*}
     */
    closeNoticeTime(val) {
      if (val) {
        this.form[this.fieldName].remind_time = val
      }
      this.$forceUpdate()
      this.noticeTimeShow = false
    },
    /**
     * @description: 提醒方式多选
     * @param {*} val
     * @return {*}
     */
    remindWayChange(val) {
      let str = ''
      if (val) {
        val.forEach((item) => {
          str += item + ','
        })
        str = str.substring(0, str.length - 1)
      }
      this.form[this.fieldName].remind_way = str
      this.$forceUpdate()
    },
    /**
     * @description: 设置提醒人
     * @return {*}
     */
    setPerson() {
      let that = this
      that.showPerson = true
      that.$refs.noticePersonSelectorRef.bindShowValue(that.form[that.fieldName].sub_business_reminder_member)
    },
    /**
     * @description: 设置提醒人关闭
     * @return {*}
     */
    close() {
      this.showPerson = false
    },
    onConfirm(val, sonTable, str) {
      this.form[this.fieldName].reminder_members = str
      this.form[this.fieldName].sub_business_reminder_member = sonTable
      this.showPerson = false
    },
    /**
     * @description: input框记录光标位置
     * @param {*} e
     * @return {*}
     */
    blurEvent(e) {
      this.blurIndex = e.srcElement.selectionStart
    },
    /**
     * @description: 变量选择
     * @param {*} val
     * @param {*} name
     * @return {*}
     */
    setField(val, name) {
      if (!this.form[this.fieldName][name]) this.form[this.fieldName][name] = ''
      let str = '{' + val.variable_name + ':' + val.variable_key + '}'
      this.form[this.fieldName][name] = this.form[this.fieldName][name].slice(0, this.blurIndex) + str + this.form[this.fieldName][name].slice(this.blurIndex)
      this.$forceUpdate()
    },
    /**
     * @description: 恢复默认
     * @return {*}
     */
    handleInitText() {
      this.$http.get('${risk}/rule/business_reminder/getDefaultRemindWordDiy/' + this.form.id).then((res) => {
        if (res.data && res.data.state) {
          this.form[this.fieldName].remind_word_diy = res.data.value
        }
      })
    },
    /**
     * @description: 提醒方式多选
     * @param {*} val
     * @return {*}
     */
    portalTypeChange(val) {
      let str = ''
      if (val) {
        val.forEach((item) => {
          str += item + ','
        })
        str = str.substring(0, str.length - 1)
      }
      this.form[this.fieldName].portal_type = str
      this.$forceUpdate()
    },
    //统计数据
    statisticsDataChange() {},
    associatedDimensionChange(val) {
      let str = ''
      if (val) {
        val.forEach((item) => {
          str += item + ','
        })
        str = str.substring(0, str.length - 1)
      }
      this.form.associated_dimension = str
      this.$forceUpdate()
    },
    /**
     * @description: 组件回调
     * @param {*} y
     * @param {*} x
     * @param {*} z
     * @return {*}
     */
    radioChange(all, y, x, z) {
      this.$set(this.form[this.fieldName], 'radioValue', String(all))
      this.$set(this.form[this.fieldName], 'probability', String(y))
      this.$set(this.form[this.fieldName], 'effect', String(x))
      this.$set(this.form[this.fieldName], 'risk_value', String(z))
      this.$forceUpdate()
    },
    addFunctionParam() {
      let index = this.functionParams.length + 1
      this.functionParams.push({
        key: 'param' + index,
        label: '函数参数' + index
      })
    },
    removeFunctionParam(index) {
      this.functionParams.splice(index, 1)
    },
    modelChange(modelKey) {
      this.fieldOptions = []
      this.functionParamsOptions = [
        {
          value: '_NOW',
          label: '当前日期'
        }
      ]
      this.$http.get('${risk}/management/risk_model/fields?voName=' + modelKey).then((res) => {
        if (res.data) {
          this.fieldOptions = res.data.map((item) => {
            this.functionParamsOptions.push({
              value: item.value,
              label: item.label
            })
            return {
              value: item.value,
              name: item.name,
              label: item.label,
              desc: item.desc,
              dataType: item.dataType
            }
          })
        }
      })
    },
    showConditionBuild() {
      if (this.form) {
        this.$refs.ruleConditionDialog.showDialog(this.fieldOptions, this.form.target_condition)
      }
    },
    conditionDialogConfirm(data) {
      let conditionDetail = JSON.parse(data)
      if (conditionDetail && conditionDetail.conditional_relation && conditionDetail.condition) {
        console.info(conditionDetail)
        this.conditionParams = conditionDetail
        // if (conditionDetail.conditional_relation === "AND" && conditionDetail.condition.length === 0) {
        //   // 初始化的对象，重置未空
        //   this.record.sub_condition_detail = {};
        // } else {
        //   this.record.sub_condition_detail = conditionDetail;
        // }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
>>> .el-dialog__body {
  padding: 0 20px 0 0;
}
.form-content {
  padding: 11px 0 20px 0;
  .title_text {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    .title_border {
      width: 4px;
      margin-right: 16px;
      height: 28px;
      background: #006af8;
      border-radius: 0 4px 4px 0;
    }
  }
}
</style>
<style>
.tabSideDrawer .el-drawer__header {
  border: bottom 0 !important;
  padding: 0 15px !important;
}
.tabSideDrawer .el-tabs__header {
  margin: 0 !important;
}
</style>
